import React, { useState } from 'react';
import './Feedback.css';

function Feedback() {
  const [formData, setFormData] = useState({
    rating: 5,
    reason: '',
    improvement: '',
    contact: '',
  });

  const [status, setStatus] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus('');

    const payload = {
      api_key: 'api-359669F6DC224EFD865964D917E622E6',
      to: ['info@peelsnativeplants.com'],
      sender: 'mail@peelsnativeplants.com',
      reply_to: 'info@peelsnativeplants.com',
      subject: 'New Feedback Submission',
      text_body: `
Rating: ${formData.rating}/10
Reason for Rating: ${formData.reason}
Suggestions for Improvement: ${formData.improvement}
Contact Info (optional): ${formData.contact}
      `.trim(),
    };

    try {
      const res = await fetch('https://api.smtp2go.com/v3/email/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.data && data.data.succeeded) {
        setStatus('Feedback submitted successfully!');
        setFormData({
          rating: 5,
          reason: '',
          improvement: '',
          contact: '',
        });
      } else {
        setStatus('Something went wrong. Please try again.');
      }
    } catch (err) {
      console.error(err);
      setStatus('Submission failed. Please check your connection.');
    }

    setSubmitting(false);
  };

  return (
    <div className="feedback-page">
      <div className="feedback-container">
        <h2>We’d Love Your Feedback</h2>
        <p className="subtitle">
          Help us improve our service by answering the questions below.
        </p>

        <form className="feedback-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="slider">
              How likely are you to recommend Peel Native Plants Ltd. to a friend or colleague?
              <span className="required">*</span>
              <br />
              <small>(0 - Not at all likely, 10 - Extremely likely)</small>
            </label>
            <input
              type="range"
              min="0"
              max="10"
              id="slider"
              name="rating"
              value={formData.rating}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>
              What is the primary reason behind the rating you provided?
              <span className="required">*</span>
            </label>
            <textarea
              name="reason"
              placeholder="Describe the reason for your rating"
              value={formData.reason}
              onChange={handleChange}
              required
              rows="4"
            />
          </div>

          <div className="form-group">
            <label>
              What could we be doing differently to increase the value of our services to you?
              <span className="required">*</span>
            </label>
            <textarea
              name="improvement"
              placeholder="Your suggestions for improvement"
              value={formData.improvement}
              onChange={handleChange}
              required
              rows="4"
            />
          </div>

          <div className="form-group">
            <label>
              Please leave your name and phone number if you’d like us to get in touch with you.
            </label>
            <textarea
              name="contact"
              placeholder="Your contact details (optional)"
              value={formData.contact}
              onChange={handleChange}
              rows="2"
            />
          </div>

          <button type="submit" className="quote-button" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit Feedback'}
          </button>

          {status && (
            <p className={`feedback-status ${status.includes('successfully') ? 'success' : 'error'}`}>
              {status}
            </p>
          )}
        </form>
      </div>
    </div>
  );
}

export default Feedback;
